import { Trans } from '@mbarzda/solid-i18next'
import type { Component } from 'solid-js'

interface SummaryCardProps {
  title: string
  value: number | string
  change: number
}

const SummaryCard: Component<SummaryCardProps> = (props) => {
  const formatValue = (): string => {
    return typeof props.value === 'number' ? props.value.toLocaleString('en-US') : props.value
  }

  const formatChange = (): string => {
    const prefix = props.change >= 0 ? '↑' : '↓'
    return `${prefix} ${Math.abs(props.change * 100).toFixed(1)}%`
  }

  const isPositive = () => props.change >= 0

  return (
    <div class="flex-1 rounded-lg border border-gray-200 bg-white p-6 text-center shadow-sm">
      <div class="flex items-center justify-center gap-3">
        <span class="text-xl font-bold text-gray-900">{formatValue()}</span>
        <span
          class="text-sm font-semibold"
          classList={{
            'text-emerald-600': isPositive(),
            'text-red-500': !isPositive()
          }}
        >
          {formatChange()}
        </span>
      </div>
      <p class="mt-1 text-xs font-semibold text-gray-500">
        <Trans key={props.title} />
      </p>
    </div>
  )
}

export default SummaryCard
